(() => {
  if (window.nunuSocialShareLoaded) return;
  window.nunuSocialShareLoaded = true;
  const roots = () => document.querySelectorAll('[data-nunu-share]');
  function closeOthers(current) {
    roots().forEach(root => { if (root !== current) root.open = false; });
  }
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-nunu-share]') && event.target.open) closeOthers(event.target);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    roots().forEach(root => {
      if (root.open) { root.open = false; root.querySelector('summary').focus(); }
    });
  });
  async function copy(root) {
    const field = root.querySelector('.nunu-share__url');
    const status = root.querySelector('[role="status"]');
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(root.dataset.url);
      field.hidden = true;
      status.textContent = root.dataset.copied;
      return true;
    } catch {
      field.hidden = false;
      field.focus();
      field.select();
      status.textContent = root.dataset.manual;
      return false;
    }
  }
  async function nativeShare(root, platform) {
    const status = root.querySelector('[role="status"]');
    const open = root.querySelector('.nunu-share__open');
    open.hidden = true;
    if (navigator.share) {
      try {
        await navigator.share({title:root.dataset.title, url:root.dataset.url});
        root.open = false;
        return;
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }
    const copied = await copy(root);
    if (copied) status.textContent = platform === 'instagram' ? root.dataset.instagramHint : root.dataset.messengerHint;
    open.href = platform === 'instagram' ? 'https://www.instagram.com/' : 'https://www.messenger.com/';
    open.textContent = platform === 'instagram' ? 'Instagram ↗' : 'Messenger ↗';
    open.hidden = false;
  }
  document.addEventListener('click', event => {
    const root = event.target.closest('[data-nunu-share]');
    if (!root) { closeOthers(null); return; }
    const copyButton = event.target.closest('[data-share-copy]');
    const nativeButton = event.target.closest('[data-share-native]');
    if (copyButton) {
      root.querySelector('.nunu-share__open').hidden = true;
      void copy(root);
    }
    if (nativeButton) void nativeShare(root, nativeButton.dataset.shareNative);
  });
})();
